import { render, staticRenderFns } from "./PropertyButton.vue?vue&type=template&id=043c71dc&scoped=true&"
import script from "./PropertyButton.vue?vue&type=script&lang=js&"
export * from "./PropertyButton.vue?vue&type=script&lang=js&"
import style0 from "./PropertyButton.vue?vue&type=style&index=0&id=043c71dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c71dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
